import { useState, useEffect, useMemo, useCallback, cloneElement, useRef } from 'react';
import { ModalsContext } from '.';
import { defaultModals } from './default-modals';

// Functions
import blockOverflow from '../../functions/block-overflow';

const defaultConfig = {
	modalInTime: 600,
	modalOutTime: 300,
	transitionTimeout: 30,
	layers: 2,
	modals: {},
	closeBtn: <button type="button" className="modal-closebtn">kapat</button>,
	styles: () => (import('./modal-styles.scss')),
}

const createLayers = (layerCount) => {
	let layers = []
	for(let k = 0; k < layerCount; k++) {
		layers.push(false);
	}
	return layers;
}

export const ModalsProvider = ({
	children,
	config: configProp,
}) => {	
	const { styles, modals: customModals, ...config } = useMemo(() => {
		return { ...defaultConfig, ...configProp };
	}, [configProp]);

	const overflowTimeout = useRef(null);

	const modals = useMemo(() => {
		return { ...defaultModals, ...customModals };
	}, [customModals]);

	const [modalData, setModalData] = useState(createLayers(config.layers));

	const closeModal = (layer) => {
		if(layer) {
			setModalData(modalData.map((layerData, nth) => ( nth === layer-1 ? false : layerData )));
		}
		else {
			setModalData(createLayers(config.layers));
		}
	};

	const openModal = (modalKey, { layer = 1, ...modalProps } = {}) => {
		const modal = modals[modalKey] ? modals[modalKey] : false;

		if(modal) {
			const currentData = [...modalData];
			
			if(config.layers.length < layer) {
				console.error(`Layer ${layer} is not present.`);
			}
			else {
				currentData[layer - 1] = { component: modal, modalProps };
				setModalData(currentData);
			}
		}
		else {
			console.error(`No modals found with name ${modalKey}`);
		}
	};

	useEffect(() => {
		const hasOpenModals = modalData.some(modal => !!modal);

		if(overflowTimeout.current) {
			clearTimeout(overflowTimeout.current);
			overflowTimeout.current = null;
		}

		if(hasOpenModals) {
			blockOverflow('modals', true);
		}
		else {
			overflowTimeout.current = setTimeout(() => {
				blockOverflow('modals', false);
				overflowTimeout.current = null;
			}, config.modalOutTime + config.transitionTimeout)
		}
	}, [modalData, config])

	return (
		<ModalsContext.Provider value={{ openModal, closeModal, closeBtn: config.closeBtn, modalData, config, styles }}>
			{children}
		</ModalsContext.Provider>
	)
}